import { useState, useContext, useEffect } from 'react'
import ApiContext from 'src/provider/API/call-service'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { AppSpan, AppText, Button, CustomContainer, FlexRow, FormGroupWithIcon, ScreenContainer } from 'src/style'
import { DecisionBox } from 'src/component'
import { QoreStaffTypes } from 'src/model'
import utility from 'src/utils/utility'
import helpers from 'src/utils/helpers'
import { FiChevronDown, FiAlertTriangle } from 'react-icons/fi'
import { BsDatabaseGear } from 'react-icons/bs'

const RunMigration = () => {
    const { API } = useContext(ApiContext)
    const { info: { qoreStaffType } } = useContext(AppInfoContext)
    const [showConfirm, setShowConfirm] = useState(false)
    const [allInstitutions, setAllInstitutions] = useState<any[]>([])
    const [selectedInstitutionId, setSelectedInstitutionId] = useState('')

    useEffect(() => {
        if (qoreStaffType && qoreStaffType !== QoreStaffTypes.DEVELOPER) {
            utility.validateRouteAccess('/dashboard/run-migration', 'SA')
        }
    }, [qoreStaffType])

    useEffect(() => {
        async function fetchInstitutions() {
            const response = await API.getAllInstitutions()
            if (response?.length) {
                setAllInstitutions(helpers.sortItemsWIthString(response, 'name', 'asc'))
            }
        }
        fetchInstitutions()
    }, [])

    const handleExecute = async () => {
        setShowConfirm(false)
        await API.executeMigration(Number(selectedInstitutionId))
    }

    if (qoreStaffType && qoreStaffType !== QoreStaffTypes.DEVELOPER) return null

    return (
        <>
            <FlexRow alignItems='center' bottomMargin='1'>
                <FlexRow
                    width='4' height='4' sizeUnit='rem'
                    alignItems='center' justifyContent='center'
                    bgColor='#E7F6F5' radius='0.8' rightMargin='1.2'
                >
                    <AppSpan textSize='1.8' color='#0D968F'>
                        <BsDatabaseGear />
                    </AppSpan>
                </FlexRow>
                <AppText textSize='2.3' color='#101828' fontWeight='700'>
                    Run Migration
                </AppText>
            </FlexRow>
            <ScreenContainer>
                <CustomContainer
                    topMargin='2' padding='2' radius='1'
                    borderColor='#EAECF0' shadow='0px 1px 3px rgba(16, 24, 40, 0.06)'
                >
                    <AppText textSize='1.5' color='#344054' bottomMargin='2'>
                        Select an institution and apply all pending database migrations for its tenant database.
                    </AppText>
                    <FlexRow justifyContent='flex-start' topMargin='1'>
                        <FormGroupWithIcon>
                            <label>Institution</label>
                            <div className='input-with-icon'>
                                <select
                                    value={selectedInstitutionId}
                                    onChange={(e) => setSelectedInstitutionId(e.target.value)}
                                    autoComplete='off'
                                >
                                    <option value=''>Select Institution</option>
                                    {allInstitutions.map((institution: any, index: number) => (
                                        <option key={index} value={institution.id}>
                                            {institution.name}
                                        </option>
                                    ))}
                                </select>
                                <FiChevronDown className='input-with-icon-tag' />
                            </div>
                        </FormGroupWithIcon>
                    </FlexRow>
                </CustomContainer>

                <FlexRow
                    topMargin='1.5' padding='1.5' radius='0.8'
                    bgColor='#FFFAEB' borderColor='#FEDF89'
                    alignItems='flex-start'
                >
                    <AppSpan textSize='1.6' color='#B54708' rightMargin='1.2'>
                        <FiAlertTriangle />
                    </AppSpan>
                    <AppText textSize='1.3' color='#B54708'>
                        This applies all pending migrations directly to the selected tenant's database and cannot be undone.
                        Only run this when you are certain it is needed.
                    </AppText>
                </FlexRow>

                <FlexRow justifyContent='flex-end' gap='2' topMargin='2' bottomMargin='3.5'>
                    <Button
                        width='14'
                        height='4'
                        radius='0.8'
                        titleSize='1.4'
                        fontWeight='600'
                        bgColor='#ffffff'
                        color='#0D968F'
                        hoverColor='#ffffff'
                        hoverBgColor='#0D968F'
                        borderColor='#0D968F'
                        onClick={() => setShowConfirm(true)}
                        disabled={!selectedInstitutionId}
                    >
                        Run Migration
                    </Button>
                </FlexRow>
            </ScreenContainer>

            {showConfirm && (
                <DecisionBox
                    message='Are you sure you want to execute database migrations for this institution? This action cannot be undone.'
                    yesBtnText='Yes, Run Migration'
                    noBtnTxt='Cancel'
                    yesMethod={handleExecute}
                    noMethod={() => setShowConfirm(false)}
                    close={() => setShowConfirm(false)}
                />
            )}
        </>
    )
}

export default utility.routeData('run-migration', 'Run Migration', <RunMigration />)
